module.exports = __webpack_public_path__ + "img/Boot - SUV NEW.4798a91a.svg";